angular.module('uofa.agentsportal')

/**
 * Branches controller for display of branches.
 *
 * @author Michael Wolfindale <m.wolfindale@abdn.ac.uk>
 */
.controller('BranchesCtrl', function BranchesCtrl($scope, $http) {

  $http.get(window.angular_datasources.config.app.url + '/api/v1/user/branches').success(function(branches) {
    $scope.branches = branches;
  });

});
